import React, { SVGProps } from 'react'
import { useTheme } from 'tamagui'

export default function WstEthIcon({ ...props }: SVGProps<SVGSVGElement>) {
  const backgroundColor = useTheme().appBg?.get()
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2776_3801)">
        <rect width="80" height="80" rx="40" fill="currentColor" />
        <path
          opacity="0.6"
          d="M54.7672 35.9437L55.1703 36.562C59.7161 43.5354 58.7009 52.6681 52.7294 58.5191C49.2164 61.9612 44.6122 63.6825 40.0079 63.683C40.0079 63.683 40.0079 63.683 54.7672 35.9437Z"
          fill={backgroundColor}
        />
        <path
          opacity="0.2"
          d="M40.006 44.3744L54.7654 35.9437C40.0061 63.683 40.006 63.683 40.006 63.683C40.006 57.6415 40.006 50.7189 40.006 44.3744Z"
          fill={backgroundColor}
        />
        <path
          d="M25.2328 35.9437L24.8297 36.562C20.2839 43.5354 21.2991 52.6681 27.2706 58.5191C30.7836 61.9612 35.3878 63.6825 39.9921 63.683C39.9921 63.683 39.9921 63.683 25.2328 35.9437Z"
          fill={backgroundColor}
        />
        <path
          opacity="0.6"
          d="M39.9876 44.3744L25.2283 35.9437C39.9877 63.683 39.9876 63.683 39.9876 63.683C39.9876 57.6415 39.9876 50.7189 39.9876 44.3744Z"
          fill={backgroundColor}
        />
        <path
          opacity="0.2"
          d="M40.0117 25.5405V40.0811L52.7253 32.8155L40.0117 25.5405Z"
          fill={backgroundColor}
        />
        <path
          opacity="0.6"
          d="M40.0079 25.5405L27.2852 32.8154L40.0079 40.0811V25.5405Z"
          fill={backgroundColor}
        />
        <path
          d="M40.0079 13.3118L27.2852 32.8199L40.0079 25.5246V13.3118Z"
          fill={backgroundColor}
        />
        <path
          opacity="0.6"
          d="M40.0117 25.5226L52.735 32.8181L40.0117 13.3003V25.5226Z"
          fill={backgroundColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_2776_3801">
          <rect width="80" height="80" rx="40" fill={backgroundColor} />
        </clipPath>
      </defs>
    </svg>
  )
}
